import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class extramarketFilterService {
  static getExtraMarketFilter(params) {
    return axiosClient
      .get("/sb/marketcategories", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
